import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { AnyPartType } from "../../../constants/partTypes";
import { useDealerPricingNotes } from "../../../stores/hooks/useDealerPricingNotes";
import { KeyValue } from "../../../ui/KeyValue/KeyValue";

export const PricingNote: FunctionComponent<{ partType: AnyPartType }> = ({
  partType,
}) => {
  const notes = useDealerPricingNotes(partType);
  const { t } = useTranslation();
  return (
    <div className="border border-edge rounded-section overflow-hidden p-2 md:p-4 flex flex-col gap-1">
      <KeyValue>
        <>{t("searchResults.pricingNote")}: </>
        <>{notes}</>
      </KeyValue>
    </div>
  );
};
